import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-703339a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bankBusiness" }
const _hoisted_2 = { class: "bankBusiness_top" }
const _hoisted_3 = { class: "bankBusiness_box" }
const _hoisted_4 = {
  key: 0,
  class: "bankBusiness_box_item"
}
const _hoisted_5 = {
  key: 1,
  class: "bankBusiness_box_item"
}
const _hoisted_6 = {
  key: 2,
  class: "bankBusiness_box_item"
}
const _hoisted_7 = {
  key: 3,
  class: "bankBusiness_box_item"
}

import TransferOfMoney from './TransferOfMoney.vue';
import BalanceEnquiry from './balance_enquiry.vue';
import DetailedInquiry from './DetailedInquiry.vue';
import ReceiptQuery from './ReceiptQuery.vue';
import dataStatistics from './dataStatistics.vue';
import { ref, reactive, onMounted } from 'vue';
import { MenuProps } from 'ant-design-vue';


import store from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

onMounted(() => {

})

let user: any = ref(store.state.user);
user.value = JSON.parse(user.value);
console.log(user.value);



const current = ref<string[]>(['0']);



//初始tab选中0
//tab数据
const items = reactive([
    {
        key: '0',
        label: '转账'
    },
    {
        key: '1',
        label: '内部明细',
        // disabled: user.value.roule === 2 ? true : false,
    },
    {
        key: '2',
        label: '明细查询',
        disabled: user.value.roule === 0 ? false : user.value.roule === 1 ? false : true,
    },
    {
        key: '3',
        label: '数据统计',
    },
    // {
    //     key: '4',
    //     label: '交易状态',
    // },
]);




return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_menu, {
        selectedKeys: current.value,
        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((current).value = $event)),
        mode: "horizontal",
        items: items
      }, null, 8, ["selectedKeys", "items"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (current.value[0] === '0')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(TransferOfMoney)
          ]))
        : _createCommentVNode("", true),
      (current.value[0] === '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(BalanceEnquiry)
          ]))
        : _createCommentVNode("", true),
      (current.value[0] === '2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(DetailedInquiry)
          ]))
        : _createCommentVNode("", true),
      (current.value[0] === '3')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(dataStatistics)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})